import { getNotificationPreferences } from '@/api/enterprise'

export const notificationPreferencesQueryKey = ['notificationPreferences'] as const

export const notificationPreferencesQuery = () => ({
  queryKey: notificationPreferencesQueryKey,
  queryFn: async () => (await getNotificationPreferences()).data,
})
